module.exports = __webpack_public_path__ + "media/pt_br_s1_Francisca.36dc284c.oga";